import { CockpitLayout, defaultVideoProperties, GridItem, ILayout, videoProperties } from "./cockpitDesigner.models";
import { ComponentKey } from "../cockpitComponents";
import { defaultRowElementProperties } from "./designer.constants";


export const MOCK_GRID_ITEMS: GridItem[] = [
  {
    id: "123411",
    components: [
      {
        name: 'toggleButton',
        id: "78675" as ComponentKey,
        position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
      {
        name: 'pushButton',
        id: "972618" as ComponentKey,
         position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
      {
        name: 'pushButton',
        id: "856321" as ComponentKey,
         position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
    ],
  },
  {
    id: "123423",
    components: [
      { name: "toggleButton",
        id: '9635261' as ComponentKey,
        position:1,
        componentSettings: {
        componentId: 'enter Id here',
        componentName: 'name'
      }
      },
      { 
        name: "toggleButton",
        id: '325142' as ComponentKey,
        position:1,
        componentSettings: {
        componentId: 'enter Id here',
        componentName: 'name'
      }
       },
    ],
  },
  {
    id: "12342",
    components: [
      { name: "pushButton",
        id: '012112' as ComponentKey,
         position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
      { name: 'pushButton',
        id: "111111" as ComponentKey,
         position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
    ],
  },
  {
    id: "92362",
    components: [
      { 
        name: 'toggleButton', 
        id: "8263728" as ComponentKey,
         position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
      { name: "pushButton", 
      id: '1213312' as ComponentKey,
       position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
    
    },
    ],
  },
  {
    id: "12345",
    components: []
  },
  {
    id: "123456",
    components: []
  },
  {
    id: "123457",
    components: []
  },
  {
    id: "123458",
    components: [
      {
        name: 'toggleButton',
        id: "181818181" as ComponentKey,
         position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
      {
        name: 'pushButton',
        id: "99898982" as ComponentKey,
        position:1,
        componentSettings: {
          componentId: 'enter Id here',
          componentName: 'name1'
        }
      },
    ],
  },
]

export const MOCK_LAYOUT: CockpitLayout = {
  videoConfig: defaultVideoProperties,
  rows: [
    {
      id: "row-1",
      height: 100,
      columns: MOCK_GRID_ITEMS,
      properties: defaultRowElementProperties
    }
  ]
};



export const firstLayout: ILayout = {
  id: crypto.randomUUID(),
  videoConfig: defaultVideoProperties,
  rowsLength: 2,
  rows: {
    'row1': {
      id: 'row1',
      height: 200,
      properties: defaultRowElementProperties,
      columnsLength: 5,
      position: 0,
      columns: {
        'col1': {
          id: '1234',
          position: 0,
          componentsLength: 1,
          components: {
            'comp1': {
              id: 'comp1',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        },
        'col2': {
          id: '1234',
          position: 0,
          componentsLength: 1,
          components: {
            'comp1': {
              id: 'comp1',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        },
        'col3': {
          id: '1234',
          position: 0,
          componentsLength: 5,
          components: {
            'comp1': {
              id: 'comp1',
              position: 0,
              name: 'toggleButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            },
            'comp2': {
              id: 'comp1',
              position: 0,
              name: 'toggleButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            },
            'comp3': {
              id: 'comp1',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            },
            'comp4': {
              id: 'comp1',
              position: 0,
              name: 'toggleButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        },
        'col4': {
          id: '1234',
          position: 0,
          componentsLength: 1,
          components: {
            'comp1': {
              id: 'comp1',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        },
        'col5': {
          id: '1234',
          position: 0,
          componentsLength: 1,
          components: {
            'comp1': {
              id: 'comp1',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        }
      }
    },
    'row2': {
      columnsLength: 1,
      position: 1,
      id: 'row2',
      properties: defaultRowElementProperties,
      height: 200,
      columns: {
        'col5': {
          id: '1234',
          componentsLength: 1,
          position: 0,
          components: {
            'comp1': {
              id: 'comp1',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        }
      }
    }
  }
}